import React from 'react';
import { useSelector } from 'react-redux';
import { Images } from 'utils';
import { FullTable } from 'components';
import { carrierInsuranceInfoBody, carrierInsuranceInfoHead } from './constants';

export const InsuranceInfo = ({}) => {
  const { carrierById } = useSelector((state) => ({
      carrierById: state.carriers.carrierById,
    }),
  );
  const insurance = carrierById?.insuranceInfo;

  return (
    <div>
      <div className="insurance-info-wrapper">
        <div>
          <p>Breakdown Insurance</p>
          <img src={insurance?.breakDownInsurance ? Images.domeMark : Images.failMark} alt="domeMark" />
        </div>
        <div>
          <p>Scheduled Autos</p>
          <img src={insurance?.scheduledAutos ? Images.domeMark : Images.failMark} alt="domeMark" />
        </div>
        <div>
          <p>Excluded Commodities</p>
          <div className='insurance-excluded-wrapper'>
          {insurance?.excludedCommodities?.length ?
            insurance?.excludedCommodities?.map((i, j) => (
            <div key={j}>
              <p >{i}</p>
            </div>
          )) : 'Not Set'}
          </div>
        </div>
      </div>


      <p className="insurance-info-title">Insurance Policies</p>
      <FullTable
        height={'small'}
        margin={'8px 0 0 0'}
        head={carrierInsuranceInfoHead}
        body={carrierInsuranceInfoBody}
        list={insurance?.insurancePolicies || []}
        noText={'Insurance Info'}
      />
    </div>
  );
};